// Library Methods
import { useTranslation } from "react-i18next";

// Components
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Alert from "src/components/shared/alerts/Alert/Alert";

// Contexts
import { useLiveUpdateContext } from "src/contexts/live-update/LiveUpdateContext";

const LiveUpdateAlerts = () => {
  const { t } = useTranslation();

  const { device, isOnline, bothControllersDisconnected, hmdInProximity } =
    useLiveUpdateContext();

  if (device && isOnline) {
    if (hmdInProximity && !bothControllersDisconnected) return null;

    const hmdText = !hmdInProximity
      ? t(
          "Exam cannot start: Please ensure the patient is wearing the Head-Mounted Display (HMD)."
        )
      : "";
    const controllerText = bothControllersDisconnected
      ? t(
          "Exam cannot start: Please ensure the controllers are connected and have sufficient battery power."
        )
      : "";

    return (
      <Alert
        variant="error"
        alertContent={
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Typography fontSize="12px">{hmdText}</Typography>
            <Typography fontSize="12px">{controllerText}</Typography>
          </Box>
        }
        props={{ borderRadius: 0, p: "8px 16px" }}
      />
    );
  }

  return (
    <Alert
      variant="error"
      alertContent={
        <Typography fontSize="12px">{t("Device is offline.")}</Typography>
      }
      props={{ borderRadius: 0, p: "8px 16px" }}
    />
  );
};

export default LiveUpdateAlerts;
